import styled from "styled-components"

export const PageTitle = styled.div<{ theme?: "light" | "dark" }>`
  font-size: 16px;
  font-style: normal;
  font-weight: 590;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.43px;
`
